
namespace TabAurous.Common {

    @Serenity.Decorators.registerClass()
    export class ProcessQIDialog extends Serenity.PropertyDialog<any, any>
    {

        protected form = new ProcessQIForm(this.idPrefix);
        public qclist: any[];
        public checksuccess: boolean;

        constructor(options:any) {
            super();
            var qcvalues = options.QCValues;
            q.hideEditorLabel(this.form.QualityInspections);
            q.hideEditorToolbar(this.form.QualityInspections);
            this.form.QualityInspections.setData(qcvalues);
        }

        protected getDialogTitle(): string {
            return "Quality Inspection";
        }

        protected onDialogOpen() {
            super.onDialogOpen();
         
        }
        getDialogOptions() {
            var options = super.getDialogOptions();
            options.height = 300;
            options.width = 850;
            return options;
        }


        protected getDialogButtons(){
            return [
                {
                    text: 'Ok',
                    click: () => {
                        var _qclist = this.form.QualityInspections.getItems();
                        for (var i = 0; i < _qclist.length; i++) {
                            if (_qclist[i].InspectedValue == "") {
                                q.alert('', 'All Quality Inspections need to be filled up', true, 2999);
                                return;
                            }
                        }
                        this.qclist = _qclist;
                        this.checksuccess = true;
                        this.dialogClose();
                    },
                },
                {
                    text: 'Cancel',
                    click: () => {
                        //this.checksuccess = false;
                        this.dialogClose();

                    }
                }
            ];
        }
    }
}